import { useAtomValue } from "jotai";
import { useEffect, useRef } from "react";
import { canvas_base64 } from "../components/dataManagers/GlobalDataManagers";
import { delay } from "./delay";

export function useProductScreenshotCapture() {
  const canvasBase64 = useAtomValue(canvas_base64);
  const canvasRef = useRef(canvasBase64);
  useEffect(() => {
    canvasRef.current = canvasBase64;
  }, [canvasBase64]);

  return async function waitForProductScreenshot({ timeoutMs = 8000, capture = true } = {}) {
    const previous = canvasRef.current;
    if (capture) {
      document.dispatchEvent(new CustomEvent("ScreenshotCanvasForCartImage"));
    } else if (canvasRef.current) {
      return canvasRef.current;
    }

    const deadline = Date.now() + timeoutMs;
    while (Date.now() < deadline) {
      await delay(100);
      if (!canvasRef.current) continue;
      if (!capture || canvasRef.current !== previous) return canvasRef.current;
    }
    throw new Error("Timed out waiting for product screenshot");
  };
}
